module.exports = __webpack_public_path__ + "img/feedback2-2.ea7eca77.jpg";